import { createSlice, createAction } from '@reduxjs/toolkit';
import { FETCH_PORTAL_DATA_FULFILLED, } from '../../actions/types/uiActions';
import { UiActions } from '../../constants/actions';
import { getDefaultTeamAccountIdFromCookie } from '../AppLayoutV2/defaultTeamAccountCookieUtils';
export var selectTeamAccount = createAction(UiActions.SELECT_TEAM_ACCOUNT);
export var initialState = {
    selectedTeamAccount: '',
};
var uiSlice = createSlice({
    name: 'ui',
    initialState: initialState,
    reducers: {},
    extraReducers: function (builder) {
        builder
            .addCase(selectTeamAccount, function (state, action) {
            state.selectedTeamAccount = action.payload;
        })
            .addCase(FETCH_PORTAL_DATA_FULFILLED, function (state, action) {
            var _a, _b, _c, _d, _e, _f;
            if ((_b = (_a = action === null || action === void 0 ? void 0 : action.meta) === null || _a === void 0 ? void 0 : _a.arg) === null || _b === void 0 ? void 0 : _b.skipAutoSelectingTeamAccount) {
                return;
            }
            var teamAccountRoles = (_d = (_c = action === null || action === void 0 ? void 0 : action.payload) === null || _c === void 0 ? void 0 : _c.teamAccountRoles) !== null && _d !== void 0 ? _d : [];
            var sanitizedTeamAccountRoles = Array.isArray(teamAccountRoles)
                ? teamAccountRoles
                : [];
            var sanitizedAdminTeamAccountsRoles = sanitizedTeamAccountRoles.filter(function (teamAccount) {
                return (teamAccount &&
                    typeof teamAccount.role === 'string' &&
                    teamAccount.role === 'ADMIN');
            });
            var defaultTeamAccountId = getDefaultTeamAccountIdFromCookie();
            var isValidDefaultTeamAccountId = sanitizedAdminTeamAccountsRoles.some(function (role) { return role.teamAccountId === defaultTeamAccountId; });
            var firstTeamAccountId = isValidDefaultTeamAccountId
                ? defaultTeamAccountId
                : (_f = (_e = sanitizedAdminTeamAccountsRoles === null || sanitizedAdminTeamAccountsRoles === void 0 ? void 0 : sanitizedAdminTeamAccountsRoles[0]) === null || _e === void 0 ? void 0 : _e.teamAccountId) !== null && _f !== void 0 ? _f : '';
            if (firstTeamAccountId) {
                state.selectedTeamAccount = firstTeamAccountId;
            }
        });
    },
});
export default uiSlice.reducer;
